import { createFileRoute, type ErrorComponentProps, useRouter } from '@tanstack/react-router';
import { ErrorOverlay } from '@/components/ErrorOverlay';
import { Section, SectionHeader } from '@/components/Section';
import { fetchOrganization } from '@/queries/organizations';
import { SecuritySection, SecuritySectionSkeleton } from '../-fragments/SecuritySection';

export const Route = createFileRoute('/system/_auth/organizations/$organizationId/others/')({
    loader: async ({ params }) => {
        const { organizationId } = params;
        return fetchOrganization({ uuid: organizationId });
    },
    pendingComponent: SystemShowOrganizationOthersRouteSkeleton,
    errorComponent: SystemShowOrganizationOthersRouteError,
    component: SystemShowOrganizationOthersRoute,
});

function SystemShowOrganizationOthersRouteError({ reset }: ErrorComponentProps) {
    return <ErrorOverlay active onRetry={reset} />;
}

function SystemShowOrganizationOthersRoute() {
    const org = Route.useLoaderData();
    const router = useRouter();

    return (
        <Section>
            <SectionHeader
                title="セキュリティ設定"
                description="クライアントユーザーの多要素認証 (MFA) を設定できます。"
            />

            <SecuritySection organization={org} onMfaToggled={() => router.invalidate()} />
        </Section>
    );
}

function SystemShowOrganizationOthersRouteSkeleton() {
    return (
        <Section>
            <SectionHeader
                title="セキュリティ設定"
                description="クライアントユーザーの多要素認証 (MFA) を設定できます。"
            />

            <SecuritySectionSkeleton />
        </Section>
    );
}
